import { render, staticRenderFns } from "./customnotice.vue?vue&type=template&id=876be7e4&"
import script from "./customnotice.vue?vue&type=script&lang=js&"
export * from "./customnotice.vue?vue&type=script&lang=js&"
import style0 from "./customnotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports